import React, { useState } from 'react';
import { MessageSquare } from 'lucide-react';
import { DraggableGrid } from '../ui/DraggableGrid';
import { ApprovalsWidget } from '../widgets/ApprovalsWidget';
import { TeamCalendarWidget } from '../widgets/TeamCalendarWidget';
import { EvaluationProgressWidget } from '../widgets/EvaluationProgressWidget';
import { OnboardingStatusWidget } from '../widgets/OnboardingStatusWidget';
import { SurveyParticipationWidget } from '../widgets/SurveyParticipationWidget';
import { TeamPerformanceWidget } from '../widgets/TeamPerformanceWidget';
import { TeamUpcomingLeavesWidget } from '../widgets/TeamUpcomingLeavesWidget';
import { BirthdaysWidget } from '../widgets/BirthdaysWidget';
import { FeedbackModal } from '../ui/FeedbackModal';
export function ManagerDashboard() {
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
  const widgets = [{
    id: 'approvals',
    component: <ApprovalsWidget data-id="element-278" />
  }, {
    id: 'birthdays',
    component: <BirthdaysWidget data-id="element-279" />
  }, {
    id: 'team-upcoming-leaves',
    component: <TeamUpcomingLeavesWidget data-id="element-280" />
  }, {
    id: 'team-calendar',
    component: <TeamCalendarWidget data-id="element-281" />
  }, {
    id: 'evaluation-progress',
    component: <EvaluationProgressWidget data-id="element-282" />
  }, {
    id: 'onboarding-status',
    component: <OnboardingStatusWidget data-id="element-283" />
  }, {
    id: 'survey-participation',
    component: <SurveyParticipationWidget data-id="element-284" />
  }, {
    id: 'team-performance',
    component: <TeamPerformanceWidget data-id="element-285" />
  }];
  return <div data-id="element-286">
      <div className="mb-8" data-id="element-287">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-288">
          <div data-id="element-289">
            <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-290">
              Tableau de bord gestionnaire
            </h1>
            <p className="text-gray-600" data-id="element-291">
              Gérez votre équipe et suivez les indicateurs clés
            </p>
          </div>
          <button onClick={() => setIsFeedbackModalOpen(true)} className="flex items-center justify-center px-6 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 shadow-sm hover:shadow-md transition-all" data-id="element-292">
            <MessageSquare className="h-5 w-5 mr-2" data-id="element-293" />
            Donner du feedback
          </button>
        </div>
        <p className="text-sm text-gray-500 mt-4" data-id="element-294">
          💡 Survolez les cartes pour les réorganiser ou redimensionner
        </p>
      </div>
      <DraggableGrid items={widgets} storageKey="manager-dashboard-layout" columns={3} data-id="element-295" />
      <FeedbackModal isOpen={isFeedbackModalOpen} onClose={() => setIsFeedbackModalOpen(false)} data-id="element-296" />
    </div>;
}